<template>
  <v-sheet>
    <v-text-field
      id="js-item-name-input"
      label="Name"
      v-model="name"
      @blur="save()"
      :rules="textFieldRules"
    ></v-text-field>
    <v-text-field
      id="js-item-description-input"
      label="Description"
      v-model="description"
      @blur="save()"
      :rules="textFieldRules"
    ></v-text-field>
    <base-editor :editable="true" :content="body" />
  </v-sheet>
</template>

<script>
import BaseEditor from "@/components/BaseEditor"
import EventBus from "@/lib/eventBus"
import eventMixin from "@/mixins/eventMixin"
import validationMixin from "@/mixins/validationMixin"

export default {
  mixins: [eventMixin, validationMixin],
  components: {
    BaseEditor
  },
  props: {
    id: { type: Number },
    initialName: { type: String },
    initialDescription: { type: String },
    initialBody: { type: String }
  },
  created() {
    this.name = this.initialName
    this.description = this.initialDescription
    this.body = this.initialBody
    EventBus.$on("editor:update", html => {
      this.body = html
      this.save()
    })
  },
  data: function() {
    return {
      body: "",
      description: "",
      name: ""
    }
  },
  beforeDestroy() {
    this.save()
    EventBus.$off("editor:update")
  },

  methods: {
    save: function() {
      this.fireEvent("learning:save", {
        id: this.id,
        body: this.body,
        description: this.description,
        name: this.name
      })
    }
  }
}
</script>
